/* 🤖 this file was generated by svg-to-ts */
export const iconUp: {
    name: 'up';
    data: string;
} = {
    name: 'up',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><path fill="#000" fill-rule="evenodd" d="m6.896.663.1.007H7l.003.001.045.01.033.008.014.005a.6.6 0 0 1 .153.072l.027.018.047.037.034.032 6.083 6.084a.65.65 0 0 1-.838.988l-.08-.069-4.975-4.974v17.946a.65.65 0 0 1-1.293.096l-.007-.096V2.882L1.272 7.856a.65.65 0 0 1-.988-.839l.069-.08L6.43.86l.006-.007.02-.018.036-.031-.056.049Q6.48.808 6.53.776l.012-.009.03-.018a.65.65 0 0 1 .324-.086"/></svg>`
};
